export const hamburger = () => {
  const headerHeight = document.querySelector('.js-header').offsetHeight;
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
  
      const href = anchor.getAttribute('href');
      const target = document.getElementById(href.replace('#', ''));
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
      });
    });
  });
  
  window.addEventListener('DOMContentLoaded', function() {
    const url = new URL(location.href);
    const hash = url.hash.slice(1);
    const target = document.getElementById(hash);
  
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
  
      setTimeout(function(){
        window.scrollTo({top: 0}, 0);
      });

      setTimeout(function(){
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      });
    }
  });

  const ham = document.querySelector('.js-hamburger'); 
  const nav = document.querySelector('.js-nav'); 
  
      ham.addEventListener('click', function () {
        ham.classList.toggle('active'); 
        nav.classList.toggle('active'); 
    });
    
    document.addEventListener("DOMContentLoaded", function () {
      ham.addEventListener("click", function () {
          const body = document.body;
          const bodyStyle = window.getComputedStyle(body);
      
          if (bodyStyle.overflow === "hidden") {
            body.style.height = "";
            body.style.overflow = "";
          } else {
            body.style.height = "100%";
            body.style.overflow = "hidden";
          }
        });
      });

      window.addEventListener('resize', function() {
        const body = document.body;
        const bodyStyle = window.getComputedStyle(body);
        if (window.innerWidth > 992) {
            ham.classList.remove('active');
            nav.classList.remove('active');
            if (bodyStyle.overflow === "hidden") {
              body.style.height = "";
              body.style.overflow = "";
            }
        }
      });

  const navLinks = nav.querySelectorAll('a');

  navLinks.forEach(function (navLink) {
    navLink.addEventListener('click', function () {
      const body = document.body;
      const bodyStyle = window.getComputedStyle(body);
      ham.classList.remove('active');
      nav.classList.remove('active');
      if (bodyStyle.overflow === "hidden") {
        body.style.height = "";
        body.style.overflow = "";
      }
    });
  });

};

window.addEventListener("scroll", function () {
  const elm = document.querySelector(".js-floating");
  const scroll = window.pageYOffset;
  const footer = document.querySelector(".l-footer").offsetTop - window.innerHeight;
  if ( scroll > 100 && footer > scroll) {
    elm.style.opacity = "1";
  } else {
    elm.style.opacity = "0";
  }
});